import { OUTPUT_ID } from './const';
var defaultSchema = { type: 'any' };
var defaultOutputId = 'then';
export default {
    '@init': function (_a) {
        var data = _a.data, setDesc = _a.setDesc, setAutoRun = _a.setAutoRun, isAutoRun = _a.isAutoRun;
        data.connectorConfig = data.connectorConfig || {};
        var autoRun = isAutoRun ? isAutoRun() : false;
        if (autoRun || data.immediate) {
            setAutoRun(true);
            data.immediate = true;
        }
        setDesc("\uFF08\u8FDE\u63A5\u5668\u4E3A\u7A7A\uFF09");
    },
    '@connectorUpdated': function (_a, _b) {
        var data = _a.data, input = _a.input, output = _a.output, setDesc = _a.setDesc, setAutoRun = _a.setAutoRun, isAutoRun = _a.isAutoRun;
        var connector = _b.connector;
        if (!data.connector)
            return;
        if (connector.id === data.connector.id) {
            updateConnector({ data: data, input: input, output: output }, connector);
            setDesc("\u5DF2\u9009\u62E9\uFF1A".concat(data.connector.title));
        }
    },
    '@connectorRemoved': function (_a, _b) {
        var _c;
        var data = _a.data, input = _a.input, output = _a.output, setDesc = _a.setDesc, setAutoRun = _a.setAutoRun, isAutoRun = _a.isAutoRun;
        var connector = _b.connector;
        if (!data.connector)
            return;
        if (connector.id === data.connector.id) {
            data.globalMock = false;
            data.connector = void 0;
            (_c = input.get('call')) === null || _c === void 0 ? void 0 : _c.setSchema(defaultSchema);
            data.outputSchema = defaultSchema;
            data.mockOutputId = defaultOutputId;
            output.get().forEach(function (o) {
                if (o.id === 'then') {
                    output.get(o.id).setSchema(defaultSchema);
                }
                else if (o.id !== 'catch') {
                    output.remove(o.id);
                }
            });
            setDesc("".concat(connector.title, " \u5DF2\u5931\u6548"));
        }
    },
    ':root': [
        {
            title: '连接器',
            type: '_connectorSelect',
            value: {
                get: function (_a) {
                    var data = _a.data;
                    return data.connector;
                },
                set: function (_a, connector) {
                    var data = _a.data, input = _a.input, output = _a.output, setDesc = _a.setDesc;
                    updateConnector({ data: data, input: input, output: output }, connector);
                    setDesc("\u5DF2\u9009\u62E9\uFF1A".concat(data.connector.title));
                }
            }
        },
        {
            title: '输出请求头(Headers)',
            type: 'switch',
            value: {
                get: function (_a) {
                    var data = _a.data;
                    return data.outputHeaders;
                },
                set: function (_a, use) {
                    var data = _a.data, output = _a.output;
                    if (use) {
                        output.add(OUTPUT_ID.HEADERS, '请求头输出项', { type: 'object', properties: {} });
                        data.outputHeaders = true;
                    }
                    else {
                        output.remove(OUTPUT_ID.HEADERS);
                        data.outputHeaders = false;
                    }
                }
            }
        },
        {
            title: '数据模拟（调试时）',
            type: 'switch',
            value: {
                get: function (_a) {
                    var data = _a.data;
                    return data.mock;
                },
                set: function (_a, use) {
                    var data = _a.data;
                    data.mock = use;
                }
            }
        },
        {
            title: '模拟输出项（调试时）',
            description: '开启数据模拟时，根据所选输出项类型进行模拟',
            type: 'select',
            options: function (_a) {
                var output = _a.output;
                return {
                    get options() {
                        return output.get().map(function (o) { return ({ label: o.title, value: o.id }); });
                    }
                };
            },
            value: {
                get: function (_a) {
                    var data = _a.data;
                    return data.mockOutputId || defaultOutputId;
                },
                set: function (_a, value) {
                    var data = _a.data, output = _a.output;
                    data.mockOutputId = value;
                    data.outputSchema = output.get(value).schema || defaultSchema;
                }
            }
        },
        {},
        {
            title: '动态配置',
            type: 'switch',
            value: {
                get: function (_a) {
                    var data = _a.data;
                    return data.showDynamicConfig;
                },
                set: function (_a, showDynamicConfig) {
                    var data = _a.data, configs = _a.configs;
                    if (showDynamicConfig) {
                        configs.add({
                            id: 'dynamicConfig',
                            title: '连接器',
                            schema: {
                                type: 'object'
                            },
                            binding: 'data.dynamicConfig',
                            editor: {
                                type: '_connectorSelect'
                            }
                        });
                    }
                    else {
                        configs.remove('dynamicConfig');
                    }
                    data.showDynamicConfig = showDynamicConfig;
                }
            }
        }
    ]
};
function isValidSchema(schema) {
    return (schema &&
        ['object', 'array', 'number', 'string', 'boolean', 'any', 'follow', 'unknown'].some(function (type) { return schema.type === type; }));
}
function updateConnector(_a, connector) {
    var input = _a.input, output = _a.output, data = _a.data;
    data.globalMock = connector.globalMock;
    data.connector = {
        id: connector.id,
        title: connector.title,
        type: connector.type,
        connectorName: connector.connectorName,
        script: connector.script,
    };
    updateIO({ input: input, output: output, data: data }, connector);
}
function updateIO(_a, connector) {
    var _b, _c;
    var input = _a.input, output = _a.output, data = _a.data;
    var callInt = input.get('call');
    if (callInt) {
        if (isValidSchema(connector.inputSchema)) {
            callInt.setSchema(connector.inputSchema);
        }
        else {
            callInt.setSchema(defaultSchema);
        }
    }
    if ((_b = connector.markList) === null || _b === void 0 ? void 0 : _b.length) {
        output.get().forEach(function (o) {
            if (o.id !== 'then' && o.id !== 'catch') {
                output.remove(o.id);
            }
        });
        (_c = connector.markList) === null || _c === void 0 ? void 0 : _c.forEach(function (mark) {
            var schema = isValidSchema(mark.outputSchema) ? mark.outputSchema : defaultSchema;
            if (mark.id === 'default') {
                var then = output.get('then');
                then.setSchema(schema);
                then.setTitle("".concat(mark.title, "(\u6807\u8BB0\u7EC4)"));
            }
            else {
                var out = output.get(mark.id);
                if (!out) {
                    output.add(mark.id, "".concat(mark.title, "(\u6807\u8BB0\u7EC4)"), schema);
                }
                else {
                    output.get(mark.id).setSchema(schema);
                }
            }
        });
    }
    else {
        output.get().forEach(function (o) {
            if (o.id === 'then') {
                output.get(o.id).setSchema(isValidSchema(connector.outputSchema) ? connector.outputSchema : defaultSchema);
            }
            else if (o.id !== 'catch') {
                output.remove(o.id);
            }
        });
    }
    /** 处理 Mock Schema */
    var allOutput = output.get();
    var curOutput = allOutput.find(function (o) { return o.id === data.mockOutputId; });
    if (curOutput) {
        data.outputSchema = output.get(curOutput.id).schema;
    }
    else {
        data.mockOutputId = defaultOutputId;
        data.outputSchema = output.get(defaultOutputId).schema;
    }
}
